import type { FaireProductEntity } from "../../entity_types/product";

export const p_433w8vb62n: FaireProductEntity = {
  token: "p_433w8vb62n",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - MAROON",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/3c8f7928c88b792bbb2f84fc61fb60c1de1816652672e043bbc956b306fc8843.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This maroon bubble skirt from Girlie Girl Originals features a bubble silhouette and is a women's skirt suitable for retail. Branded by Girlie Girl Originals, it complements fashion-forward collections with southern flair and bold, fun style. Please reach out to receive a copy of our MAP (minimum advertised price) policy.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:34.549Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
